import { render, staticRenderFns } from "./more_operate.vue?vue&type=template&id=a8bc5abc&scoped=true&"
import script from "./more_operate.vue?vue&type=script&lang=ts&"
export * from "./more_operate.vue?vue&type=script&lang=ts&"
import style0 from "./more_operate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./more_operate.vue?vue&type=style&index=1&id=a8bc5abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bc5abc",
  null
  
)

export default component.exports